<template>
  <div>
    <v-toolbar
      flat
      color="white"
    >
      <v-text-field
        v-model="search"
        prepend-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog
        v-model="dialog"
        max-width="700px"
        scrollable
      >
        <v-btn
          slot="activator"
          icon
        >
          <v-icon>add_circle_outline</v-icon>
        </v-btn>
        <v-card>
          <v-card-text>
            <v-container grid-list-md>

              <v-layout wrap>
                <p>General Informations</p>
              </v-layout>
              <v-layout
                row
                wrap
              >
                <v-flex
                  lg6
                  sm4
                >
                  <v-autocomplete                    
                    hint="Atleast 3 Characters required"
                    :loading="loader"                    
                    flat
                    placeholder="Select only suggested Machine"
                    :items="machineList"
                    v-model="editedItem.machineCode"
                    label="Machine"
                    @change="machineSelect"
                    auto
                    chips
                    prepend-icon="track_changes"
                    required
                    item-text="name"
                    item-value="no"
                  ></v-autocomplete>

                </v-flex>
                <v-flex
                  lg6
                  sm4
                >
                  <v-text-field
                    label="No of Cuts"
                    prepend-icon="ac_unit"
                    name="user"
                    v-model="editedItem.noOfCuts"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  lg6
                  sm6
                >

                  <v-autocomplete                    
                    hint="Atleast 3 Characters required"
                    :loading="loader"                   
                    flat
                    placeholder="Select only suggested Attached Layout Plan"
                    :items="wikilists"
                    v-model="editedItem.attachedlayoutPlan"
                    label="Attached Layout Plan"
                    auto
                    chips
                    prepend-icon="attach_file"
                    required
                    item-text="name"
                    item-value="name"
                  ></v-autocomplete>
                </v-flex>
              </v-layout>

              <v-layout
                row
                wrap
              >
                <v-flex
                  lg6
                  sm6
                >
                  <p>Scrap Informations - (Allowable Quantity)</p>
                </v-flex>

              </v-layout>
              <v-layout
                row
                wrap
              >
                <v-flex
                  lg4
                  sm4
                >
                  <v-autocomplete                    
                    hint="Atleast 3 Characters required"
                    :loading="loader"                    
                    flat
                    placeholder="Select only suggested Blister Type"
                    :items="blisterTypes"
                    v-model="editedItem.blisterScrapTypeId"
                    label="Blister Type"
                    auto
                    chips
                    prepend-icon="track_changes"
                    required
                    item-text="name"
                    item-value="scrapCodeID"
                    @change="blisterSelect"
                  ></v-autocomplete>
                </v-flex>
                <v-flex
                  lg4
                  sm4
                >
                  <v-text-field
                    label="Scrap Value"
                    prepend-icon="exit_to_app"
                    type="number"
                    suffix="KG"
                    v-model="editedItem.blisterValue"
                  >
                  </v-text-field>
                </v-flex>

              </v-layout>

            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              outline
              @click.native="close"
            >Cancel</v-btn>
            <v-btn
              color="blue darken-1"
              outline
              @click.native="save"
            >Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>

    <app-section-loader :status="loader"></app-section-loader>
    <v-data-table
      :headers="headers"
      :items="gridItems"
      :search="search"
      class="elevation-1"
      default-sort="BlisterScrapId:desc"
    >
      <template
        slot="items"
        slot-scope="props"
      >

        <td>{{ props.item.machineCode }}</td>
        <td class="text-xs-left">{{ props.item.noOfCuts }}</td>
        <td class="text-xs-left">{{ props.item.attachedlayoutPlan }}</td>
        <td class="text-xs-left">{{ props.item.blisterType }}</td>
        <td class="text-xs-left">{{ props.item.blisterValue }}</td>

        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="onDeleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template slot="no-data">
        <v-btn
          color="primary"
          outline
          @click="initialize"
        > Record not exist.Refresh again in while time.</v-btn>
      </template>
    </v-data-table>
    <v-snackbar
      :top="y === 'top'"
      :timeout="timeout"
      v-model="snackbar"
    >
      {{ snackbarMessage }}
    </v-snackbar>
    <delete-confirmation-dialog
      ref="deleteConfirmationDialog"
      heading="Are You Sure You Want To Delete?"
      message="Are You Sure You Want To Delete This Item Permanently?"
      @onConfirm="deleteItem"
    >
    </delete-confirmation-dialog>
  </div>
</template>
<script>
import { getScrapType, } from '@/api/BlisterScrapEntry';
import { getBlisterScrapAllowable } from '@/api/blisterScrapAllowable';
import { getMachine } from '@/api/navService';
export default {
  data: () => ({
    dialog: false,
    loader: false,
    search: '',
    statusOptions: [
      { text: 'Active', value: 1 },
      { text: 'InActive', value: 2 }
    ],
    blisterTypes: [],
    wikilists: [
      { id: 1, name: 'Temperature Mapping - Report- Intermediate Room (Granule)' },
      { id: 2, name: 'Temperature Mapping - Report (Chiller) - TMP-18-02' },
      { id: 3, name: 'PQ - ZP33 Tablet Press Machine' },
      { id: 4, name: 'PQ - Kobelco Compressed Air System (KS45A)' },
    ],
    machineList: [
    ],
    form: {
      userName: 'SW Task',
      cardTypeId: 1,
      startDate: '2018-04-09',
      endDate: '2018-04-09',
      login: 'yes-1',
      date: '2018-04-09',
      noOfCuts: 1,
    },
    snackbar: false,
    snackbarMessage: '',
    timeout: 2000,
    y: 'top',
    headers: [
      { text: 'Machine Code', value: 'MachineCode', align: 'left' },
      { text: 'No Of Cuts', value: 'NoOfCuts', align: 'left' },
      { text: 'Attached layout Plan', value: 'AttachedlayoutPlan', align: 'left' },
      { text: 'Blister Type', value: 'blisterType', align: 'left' },
      { text: 'Scrap Value(KG)', value: 'Value', align: 'left' },

      { text: 'Actions', value: 'name', sortable: false, align: 'left' }
    ],
    gridItems: [],
    editedIndex: -1,
    selectedItem: null,
    editedItem: {
      valid: false,
      blisterScrapId: -1,
      machineCode: '',
      requiredfield: [v => !!v || 'This is required field'],
      noOfCuts: '',
      attachedlayoutPlan: '',
      blisterType: '',
      blisterValue: null,
      blisterScrapTypeId: null,
      machineId: null,

    },
    defaultItem: {
      blisterScrapId: -1,
      machineCode: '',
      requiredfield: [v => !!v || 'This is required field'],
      noOfCuts: '',
      attachedlayoutPlan: '',
      blisterType: '',
      blisterValue: null,
      blisterScrapTypeId: null,
      machineId: null,
    },
    blisterScrapId: -1,
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Add Blister Allowable' : 'Edit Blister Allowable';
    }
  },

  watch: {
    dialog (val) {
      val || this.close();
    }
  },

  created () {
    this.initialize();
  },

  methods: {
    initialize () {
      this.loader = true;

      if (this.blisterScrapId != -1) {

        getBlisterScrapAllowable(this.blisterScrapId)
          .then(response => {
            this.gridItems = response.data;
            this.loader = false;

          })
          .catch(error => {
            this.loader = false;
            window.getApp.$emit('APP_API_ERROR', error);
          });
      }
      getScrapType('')
        .then(response2 => {
          this.blisterTypes = response2.data;
          this.loader = false;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

      getMachine()
        .then(response => {
          this.machineList = response.data;

          this.loader = false;

        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });

    },
    editItem (item) {
      this.editedIndex = this.gridItems.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    onDeleteItem (item) {
      this.$refs.deleteConfirmationDialog.openDialog();
      this.selectedItem = item;
    },

    deleteItem (item) {
      const index = this.gridItems.indexOf(this.selectedItem);
      this.$refs.deleteConfirmationDialog.close();
      this.gridItems.splice(index, 1);
    },

    close () {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save () {

      if (this.editedIndex > -1) {
        Object.assign(this.gridItems[this.editedIndex], this.editedItem);
      } else {
        this.gridItems.push(this.editedItem);
      }
      this.close();
    },
    machineSelect (label) {
      // let uom = this.machineList.filter(o => o.no == label);
      // this.editedItem.machineCode = uom[0].name;
    },
    blisterSelect (label) {
      let uom = this.blisterTypes.filter(o => o.scrapCodeID == label);
      this.editedItem.blisterType = uom[0].name;
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/scrap/BlisterScrapAllowableList.vue